import { render, staticRenderFns } from "./ForumPostPreview.vue?vue&type=template&id=84de00c0&scoped=true"
import script from "./ForumPostPreview.vue?vue&type=script&lang=js"
export * from "./ForumPostPreview.vue?vue&type=script&lang=js"
import style0 from "./ForumPostPreview.vue?vue&type=style&index=0&id=84de00c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84de00c0",
  null
  
)

export default component.exports